import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './EmployeeSideBarContent.scss'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { useAuth } from 'Components/AuthProvider/AuthProvider'
import { ACTIVEMENU } from 'Constants/MobileMenuConstants'
import MessageSvg from 'Components/Svgs/Message'
import AvatarSvg from 'Components/Svgs/Avatar'
import ThumbsUpSvg from 'Components/Svgs/ThumbsUp'
import HomeSvg from 'Components/Svgs/Home'
import { useEmployeeProfile } from 'Context/ProfileContext'
import TgSvg from 'Components/Svgs/TgSvg'
import LogoutSvg from 'Components/Svgs/Logout'
import Swal from 'sweetalert2'
import ArrowDown from 'Assets/Icons/arrow-down-black.png'

const EmployeeSideBarContent = () => {
  const { logout: auth0Logout } = useAuth0()

  // const location = useLocation()
  const dispatch = useDispatch()

  const { user, logout } = useAuth()

  const { profile } = useEmployeeProfile()

  const isExitedUser = ['ON_OFFBOARDING', 'COMPLETED_OFFBOARDING', 'TERMINATED'].includes(
    profile?.employmentStatus || '',
  )

  function setLink(name: string) {
    dispatch({
      type: ACTIVEMENU,
      payload: {
        name,
        user: {
          loanProvider: user?.user?.loanProvider,
          loanProviderAdminRole: user?.loanProviderAdminRole,
        },
      },
    })
  }

  useEffect(() => {
    // set Default route name
    setLink('Dashboard')
  }, [])

  const handleLogout = () => {
    if (user?.user.name) {
      auth0Logout({ logoutParams: { returnTo: window.location.origin } })
      logout()
    } else {
      localStorage.removeItem('__TG-EMP')
      localStorage.removeItem('loginTime')
      window.location.href = '/login'
    }
  }

  const closeOffcanvas = () => {
    const offcanvasElement = document.getElementById('offcanvasExample')
    const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasElement)
    if (bsOffcanvas) {
      bsOffcanvas.hide()
    }
  }
  // console.log('user empNav', user)
  const navigate = useNavigate()

  const switchAdmin = () => {
    Swal.fire({
      title: 'Switch...',
      text: 'Loading admin dashboard configurations, please wait',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    setTimeout(() => {
      Swal.close()
      navigate('/admin')
    }, 4000)
  }

  const role = useSelector((state: { role: string }) => state.role)
  const [open, setOpen] = useState(true)

  return (
    <React.Fragment>
      <div className='asc'>
        <ul className='nav flex-column mb-4 main-nav'>
          <li className='nav-item my-1 mt-4 mb-5 ps-3 d-none d-xl-block'>
            <div className='logoToggle'>
              <Link to='/dashboard' onClick={() => closeOffcanvas()}>
                <TgSvg />
              </Link>

              <button
                className={`btn ${
                  ['admin', 'hr', 'finance', 'management', 'manager'].includes(user.role) ||
                  (['admin', 'hr', 'finance', 'management', 'manager'].includes(role) &&
                    !isExitedUser)
                    ? ''
                    : 'd-none'
                }`}
                type='button'
                onClick={() => setOpen((prev) => prev)}
              >
                <img src={ArrowDown} alt='icon' className={`arrow invisible ${open ? 'arrow-open' : ''}`} />
              </button>
            </div>

            {(['admin', 'hr', 'finance', 'management', 'manager'].includes(user.role) ||
              (['admin', 'hr', 'finance', 'management', 'manager'].includes(role) &&
                !isExitedUser)) && (
              <div className={`dropdown-menu p-4 text-muted ${open ? 'show' : ''}`}>
                <a
                  className={`${isExitedUser ? 'disabled' : ''}`}
                  href='#'
                  onClick={(e) => {
                    if (isExitedUser) {
                      e.preventDefault()
                      return
                    }
                    switchAdmin()
                  }}
                >
                  <i className='d-icon d-switch'></i> Switch to Admin
                </a>
              </div>
            )}
          </li>

          <div
            className={`scroll-vertica ${
              ['admin', 'hr', 'finance', 'management', 'manager'].includes(user.role) ||
              (['admin', 'hr', 'finance', 'management', 'manager'].includes(role) && !isExitedUser)
                ? 'push-down'
                : ''
            }`}
          >
            <li className='nav-item'>
              <NavLink
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                to={'/'}
                onClick={() => {
                  setLink('Dashboard')
                  closeOffcanvas()
                }}
              >
                <HomeSvg />
                <span>Dashboard</span>
              </NavLink>
            </li>

            <li className='nav-item'>
              <NavLink
                className={({ isActive }) =>
                  !isExitedUser && isActive ? 'nav-link active' : 'nav-link'
                }
                to={isExitedUser ? '/' : '/profile'}
                onClick={() => {
                  setLink('Profile')
                  closeOffcanvas()
                }}
              >
                <AvatarSvg />
                <span>Profile</span>
              </NavLink>
            </li>

            <li className='nav-item'>
              <NavLink
                className={({ isActive }) =>
                  !isExitedUser && isActive ? 'nav-link active' : 'nav-link'
                }
                to={isExitedUser ? '/' : '/appraisals'}
                onClick={() => {
                  setLink('Appraisal')
                  closeOffcanvas()
                }}
              >
                <ThumbsUpSvg />
                <span>Appraisal</span>
              </NavLink>
            </li>

            <li className='nav-item'>
              <NavLink
                className={({ isActive }) =>
                  !isExitedUser && isActive ? 'nav-link active' : 'nav-link'
                }
                to={isExitedUser ? '/' : '/leave'}
                onClick={() => {
                  setLink('Leave')
                  closeOffcanvas()
                }}
              >
                <MessageSvg />
                <span>Leave</span>
              </NavLink>
            </li>

            <li className='nav-item'>
              <NavLink
                className={({ isActive }) =>
                  !isExitedUser && isActive ? 'nav-link active' : 'nav-link'
                }
                to={isExitedUser ? '/' : '/policies'}
                onClick={() => {
                  setLink('Policies')
                  closeOffcanvas()
                }}
              >
                <MessageSvg />
                <span>Policies</span>
              </NavLink>
            </li>

            <li className='nav-item'>
              <NavLink
                className={({ isActive }) =>
                  !isExitedUser && isActive ? 'nav-link active' : 'nav-link'
                }
                to={isExitedUser ? '/' : '/loan'}
                onClick={() => {
                  setLink('Loan')
                  closeOffcanvas()
                }}
              >
                <MessageSvg />
                <span>Loan</span>
              </NavLink>
            </li>

            <li className='nav-item'>
              <NavLink
                className={({ isActive }) =>
                  !isExitedUser && isActive ? 'nav-link active' : 'nav-link'
                }
                to={isExitedUser ? '/' : '/events'}
                onClick={() => {
                  setLink('Events')
                  closeOffcanvas()
                }}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    opacity='0.4'
                    d='M21.0407 7.19L12.0007 12.42L2.96069 7.19C3.36069 6.45 3.94069 5.8 4.59069 5.44L9.93069 2.48C11.0707 1.84 12.9307 1.84 14.0707 2.48L19.4107 5.44C20.0607 5.8 20.6407 6.45 21.0407 7.19Z'
                    fill='#516F93'
                  />
                  <path
                    opacity='0.6'
                    d='M12.0006 12.4199V21.9999C11.2506 21.9999 10.5006 21.8399 9.93062 21.5199L4.59063 18.5599C3.38063 17.8899 2.39062 16.2099 2.39062 14.8299V9.16994C2.39062 8.52994 2.61062 7.82994 2.96062 7.18994L12.0006 12.4199Z'
                    fill='#516F93'
                  />
                  <path
                    d='M21.6107 9.16994V14.8299C21.6107 16.2099 20.6207 17.8899 19.4107 18.5599L14.0707 21.5199C13.5007 21.8399 12.7507 21.9999 12.0007 21.9999V12.4199L21.0407 7.18994C21.3907 7.82994 21.6107 8.52994 21.6107 9.16994Z'
                    fill='#516F93'
                  />
                </svg>
                <span>Events</span>
              </NavLink>
            </li>

            {/* <li className="nav-item">
                <NavLink className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                    to="/benefits"
                    onClick={()=>setLink('Benefits')}> 
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path opacity="0.4" d="M19.9697 10V18C19.9697 21 18.9697 22 15.9697 22H7.96973C4.96973 22 3.96973 21 3.96973 18V10H19.9697Z" fill="#6A80A3"/>
                      <path d="M21.5 7V8C21.5 9.1 20.97 10 19.5 10H4.5C2.97 10 2.5 9.1 2.5 8V7C2.5 5.9 2.97 5 4.5 5H19.5C20.97 5 21.5 5.9 21.5 7Z" fill="#6A80A3"/>
                      <path opacity="0.4" d="M11.6398 5.00043H6.11978C5.77978 4.63043 5.78978 4.06043 6.14978 3.70043L7.56978 2.28043C7.93978 1.91043 8.54978 1.91043 8.91978 2.28043L11.6398 5.00043Z" fill="#6A80A3"/>
                      <path opacity="0.4" d="M17.8696 5.00043H12.3496L15.0696 2.28043C15.4396 1.91043 16.0496 1.91043 16.4196 2.28043L17.8396 3.70043C18.1996 4.06043 18.2096 4.63043 17.8696 5.00043Z" fill="#6A80A3"/>
                      <path opacity="0.6" d="M8.94043 10V15.14C8.94043 15.94 9.82043 16.41 10.4904 15.98L11.4304 15.36C11.7704 15.14 12.2004 15.14 12.5304 15.36L13.4204 15.96C14.0804 16.4 14.9704 15.93 14.9704 15.13V10H8.94043Z" fill="#6A80A3"/>
                    </svg>
                    <span>Benefits</span>
                </NavLink>
              </li>   */}

            {/* <li className="nav-item">
                <NavLink className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                    to="/resources"
                    onClick={()=>setLink('Resources')}>  
                       <img src={resource} alt="" className='m-1 rounded-circle' />

                       <span>Resources</span>
                </NavLink>
              </li>  */}

            <li className='nav-item'>
              <a
                className={'nav-link'}
                href={'/'}
                onClick={() => {
                  setLink('Transactions')
                  handleLogout()
                }}
              >
                <LogoutSvg />
                <span>Logout</span>
              </a>
            </li>
          </div>
        </ul>
      </div>
    </React.Fragment>
  )
}

export default EmployeeSideBarContent
